import { http, HttpResponse, delay } from 'msw'

export const handlers = [
  http.post('/handy/*/trial/accept', async () => {
    await delay(2000)
    return new HttpResponse(null, { status: 200 })
  }),
]
